import React from 'react';
import {MessageRender,MessageRenderProps} from './MessageRender';

export const Message = (props:MessageRenderProps):JSX.Element=>{
	return <MessageRender {...props}/>;
};
